import TransporterLog from "./class.TransporterLog";
import zData from "../z_data.json";

const LOGGER = new TransporterLog({
	attributes: {
		name: "TransporterUtils",
		color: "magenta",
	},
});

export function ExecuteWhenTypesLoaded(callback) {
	if (_.isUndefined(AoPS.Transporter.CompositeObjectTypes)) {
		AoPS.Transporter.ZInputData = zData;
		AoPS.Transporter.CompositeObjectTypes = {};
		_.each(zData.data_types, function (ot) {
			var fields = _.isArray(ot.fields) ? ot.fields.slice(0) : [];
			var current = ot,
				base,
				nested = _.extend({}, ot);
			while (current.base_type) {
				if (
					(base = _.findWhere(zData.data_types, {
						type: current.base_type,
					}))
				) {
					fields = [].concat(base.fields || [], fields);
					nested = _.extend({}, base, nested);
					current = base;
				} else {
					break;
				}
			}
			if (nested.is_object) {
				fields = _.reduce(
					fields,
					function (carry, item) {
						var found = _.findWhere(carry, {field: item.field});
						if (found) {
							carry[carry.indexOf(found)] = _.extend({}, found, item);
						} else {
							carry.push(item);
						}
						return carry;
					},
					[]
				);
				fields.sort(function (l, r) {
					if (_.isUndefined(l.order) && _.isUndefined(r.order)) {
						return 0;
					} else if (_.isUndefined(l.order)) {
						return 1;
					} else if (_.isUndefined(r.order)) {
						return -1;
					} else {
						return l.order - r.order;
					}
				});
				var obj = _.reduce(
					fields,
					function (carry, item) {
						if (item.field) {
							carry[item.field] = item.default;
						}
						return carry;
					},
					{}
				);
				nested = _.extend(nested, {
					fields: fields,
					default_object: obj,
				});
			}
			AoPS.Transporter.CompositeObjectTypes[ot.type] = nested;
		});
		if (_.isFunction(callback)) {
			callback();
		}
	} else {
		if (_.isFunction(callback)) {
			callback();
		}
	}
}

/******************************
 * Mathjax Rendering Helpers. *
 ******************************/

/**
 * Queues a typeset event with Mathjax on the desired element.
 * Returns a promise.
 * @param {HTMLElement} element
 * @returns {Promise} A promise.
 */
export function requestMathJaxRender(element) {
	return new Promise((resolve, reject) => {
		if ("MathJax" in window) {
			MathJax.Hub.Queue(["Typeset", MathJax.Hub, element]);
			MathJax.Hub.Queue([
				() => {
					resolve();
				},
			]);
		} else {
			reject("MathJax was not found.");
		}
	});
}

/**
 * A helper function which will render the MathJax into a target.
 * @param {*} $mainViewEl Parent element, for appending
 *  	a place where the Mathjax can hide until it's done rendering.
 * @param {*} $target Where the mathjax will be rendered.
 * @param {string} jax Mathjax to be rendered.
 */
export async function renderJax($mainViewEl, $target, jax) {
	let renderIndex = $target.data("mathjax-render-index") || 0;
	$target.data("mathjax-render-index", ++renderIndex);
	let $renderBox = $(`<div class="render-box"/>`).css({
		position: "fixed",
		top: "-100vh",
		left: "-100vw",
		height: "100vh",
		width: "100vw",
		overflow: "none",
		"white-space": "nowrap",
		visibility: "hidden",
		"pointer-events": "none",
		"z-index": "-99999",
	});
	$mainViewEl.append($renderBox);
	$renderBox.text(jax);
	await requestMathJaxRender($renderBox[0]);
	if (renderIndex === $target.data("mathjax-render-index")) {
		$target.html($renderBox.html());
	}
	$renderBox.remove();
}

/**
 * A helper function which will attempt to focus the first input box
 * in a MathjaxBlank motor as soon as it appears.
 * @param {*} $motorDiv The div the motor is rendered in.
 * @param {number} checkMs The interval to check.
 * @param {number} timeoutMs The timeout to give up.
 */
export function focusWhenPossible($motorDiv, checkMs = 200, timeoutMs = 3000) {
	const interval = setInterval(() => {
		const $input = $motorDiv.find("input:first");
		if ($input.length) {
			$input.focus();
			clearInterval(interval);
		}
	}, checkMs);

	setTimeout(() => {
		clearInterval(interval);
	}, timeoutMs);
}

/**
 * Escapes some characters that will mess up latex output.
 * @param {string} jax
 */
export function sanitizeJax(jax) {
	if (!_.isString(jax)) {
		return "";
	}
	return Motors.sanitizeJax(jax);
}

/**
 * Reforms user-input Jax to look nicer, e.g. reformat mixed numbers.
 * @param {string} jax
 */
export function reformatJax(jax) {
	if (!_.isString(jax)) {
		return "";
	}
	return Motors.reformatJax(jax);
}

/************************
 * Flow/Runner Helpers. *
 ************************/

/**
 * Returns a promise for a prompt.
 * @param {string} prompt
 * @param {string[]} buttons button text
 * @returns {Promise<boolean>} A Promise which resolves with true or false.
 */
export function asyncPrompt(prompt, buttons) {
	return new Promise((resolve) => {
		AoPS.Ui.Modal.showButtons(
			prompt,
			buttons.map((n, i) => {
				return {text: n, value: i};
			}),
			(n) => resolve(n),
			{
				onClose: () => {
					resolve(null);
				},
			}
		);
		const $modalWrapper = $(".aops-modal-wrapper");
		$modalWrapper.on("click", (event) => {
			if ($(event.target).is($modalWrapper)) {
				resolve(null);
			}
		});
	});
}

/**
 * Duplicate of Runner function.
 */
export function createFlowTraverseList(pointer, item, flowList) {
	var partial = [];
	_.each(flowList, (flowItem) => {
		if (_.isObject(flowItem) && flowItem.call) {
			partial.push({
				pointer: pointer.concat([flowItem]),
				action: flowItem.call,
			});
		} else if (_.isObject(flowItem) && flowItem.traverse) {
			_.each(
				_.isArray(item[flowItem.traverse])
					? item[flowItem.traverse]
					: [item[flowItem.traverse]],
				(sub, index) => {
					if (_.isObject(sub)) {
						var sub_type = AoPS.Transporter.CompositeObjectTypes[sub.type];
						if (sub_type && sub_type.flow) {
							partial.push({
								pointer: pointer.concat([flowItem.traverse, index]),
							});
						}
					}
				}
			);
		}
	});
	return partial;
}

/**
 * Duplicate of Runner function.
 */
export function getPointerString(pointer, context) {
	var str = "";
	if (pointer) {
		for (let i = 0; i < pointer.length; i++) {
			let node = pointer[i];
			if (typeof node === "object") {
				node = [node.call, node.traverse].join("");
			}
			str += String(node);
		}
		str = [context, str].join("");
	}
	return str;
}

/**
 * Slightly modified version from Runner.
 * @param {*} pointer
 * @param {*} root
 */
export function findItemByPointer(pointer, root) {
	return _.reduce(
		pointer,
		(carry, item) => {
			if (_.isObject(item)) {
				return carry;
			} else {
				return _.isObject(carry) || _.isArray(carry) ? carry[item] : undefined;
			}
		},
		root
	);
}

/**
 * Inserts a Transporter demo into a jQuery object.
 * Callback will be executed once Transporter is initialized,
 * with a reference to the Transporter controller as the argument.
 *
 * @param {jQuery} $container
 * @param {(transporter: Transporter) => void} callback
 */
export function initializeDemo($container, callback, tablet = false) {
	if (!$container || !($container instanceof window.jQuery)) {
		return LOGGER.error("$container must be a jQuery object.");
	}

	const documentId = parseInt($container.attr("data-document")) || 0;
	const version = parseInt($container.attr("data-version")) || 0;

	if (!documentId) {
		return LOGGER.error("data-document attribute is invalid.");
	}

	$.post(
		"/s/transporter/ajax.php",
		{
			a: "get_demo_document",
			document_id: documentId,
			version: version,
		},
		(data) => {
			if (data.error_code) {
				return LOGGER.error(data.error_code, data.error_msg);
			}

			const document = data.response.document;

			$container.html("");
			const transporter = new AoPS.Transporter.Main({
				attributes: {
					document: document,
					document_id: documentId,
					version: version,
					progress: null,
					onInitialize: (controller) => {
						if (tablet) {
							const $tabletView = $(`
								<div class="transporter-tablet-view">
									<div class="transporter-tablet-container"></div>
								</div>
							`);
							$tabletView
								.find(".transporter-tablet-container")
								.append(controller.mainView.$el);
							$container.append($tabletView);
						} else {
							$container.append(controller.mainView.$el);
						}
						controller.mainView.$el.find(".error-icon").hide();
						callback(transporter);
					},
					onProgress: () => {},
					disableProgressModal: true,
					demoMode: true,
				},
			});
		}
	);
}

/**
 * get the background image of the $container
 *
 * @param {string} AJAX action
 * @param {jQuery} $container
 * @param {int} document_id
 * @param {int} version
 * @param {Function} callback function to call instead of attaching to container
 */
export function getDocumentImageFile(
	action,
	$container,
	document_id,
	version,
	callback = null
) {
	$.post(
		"/s/transporter/ajax.php",
		{
			a: action,
			document_id: document_id,
			version: version,
		},
		(data) => {
			if (data.error_code) {
				return LOGGER.error(data.error_code, data.error_msg);
			}
			if (data.response.image_url) {
				if (callback) {
					callback("https://cdn.aopstest.com//" + data.response.image_url);
				} else {
					$container.css({
						"background-image":
							"url('https://cdn.aopstest.com//" +
							data.response.image_url +
							"')",
						"background-size": "cover",
					});
				}
			} else {
				if (callback) {
					callback(null);
				}
			}
		}
	);
}

/**********************
 * Browser Detection. *
 **********************/

/**
 * Returns true if browser is IE < 12 or non-Chromium Opera.
 *
 * @returns {boolean}
 */
export function detectIncompatibleBrowser() {
	const ie = detectIE();
	const opera = detectOldOpera();

	if (opera || (ie && ie < 12)) {
		return true;
	}
}

/**
 * Returns the version number of the browser if the browser is IE/Edge,
 * where Edge returns 12. Other browsers return false.
 *
 * @returns {number|false} A number if a version of IE (12 being Edge), or false if not IE.
 */
export function detectIE() {
	const ua = window.navigator.userAgent;

	const msie = ua.indexOf("MSIE ");
	if (msie > 0) {
		// IE 10 or older => return version number
		return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
	}

	const trident = ua.indexOf("Trident/");
	if (trident > 0) {
		// IE 11 => return version number
		var rv = ua.indexOf("rv:");
		return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
	}

	const edge = ua.indexOf("Edge/");
	if (edge > 0) {
		// Edge (IE 12+) => return version number
		return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
	}

	// other browser
	return false;
}

/**
 * Returns true on non-Chromium versions of Opera.
 *
 * @returns {boolean}
 */
export function detectOldOpera() {
	return window.opera && window.opera.toString() === "[object Opera]";
}

/**
 * Returns true on iPad, iPhone, iPod.
 *
 * @returns {boolean}
 */
export function detectIOS() {
	return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
}
